/* unplugin-vue-components disabled */import script from "./media-coverage.vue?vue&type=script&setup=true&lang=ts"
export * from "./media-coverage.vue?vue&type=script&setup=true&lang=ts"

import "./media-coverage.vue?vue&type=style&index=0&id=6b9b8c3d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b9b8c3d"]])

export default __exports__